<template>
  <popup
    :opened="confirmDeactivateTemplate > -1"
    @close="close"
  >
    <!-- Screen to ask a confirmation to close current evaluation -->
    <div v-if="confirmDeactivateTemplate == 0">
      <div class="my-5 xl:my-15">
        <h3 class="mb-5 md:mb-10 2xl:mb-15">
          Desactiver le modèle de page "{{ templateNameToDeactivate }}"
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Êtes-vous sûr de vouloir désactiver le modèle de page "{{ templateNameToDeactivate }}" ?
          </p>
        </div>

        <div class="flex space-x-4 justify-center bg-pink">
          <action-button
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-300"
            libelle="ANNULER"
            @clickAction="close(-1)"
          />
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            :uppercase="true"
            libelle="Désactiver"
            type-shadow="shadow-pink"
            @clickAction="confirm_deactivate_template"
          />
        </div>
      </div>
    </div>
    <!-- END Screen to ask a confirmation to close current evaluation -->

    <!-- Screen to confirm the close -->
    <div v-if="confirmDeactivateTemplate == 1">
      <h3 class="w-full text-indigo-600 mt-12 mb-10">
        Le modèle de page "{{ templateNameToDeactivate }}"<br>a bien été désactivé !
      </h3>
      <illustration
        name="basket"
        class="  w-full m-5"
      />
    </div>
    <!-- END Screen to confirm the close -->

    <!-- If template to delete is assigned on at least 1 beneficiary -->
    <div v-if="confirmDeactivateTemplate == 2">
      <div class="my-5 xl:my-15">
        <h3 class="mb-5 md:mb-10 2xl:mb-15">
          Désactiver le modèle de page "{{ templateNameToDeactivate }}"
        </h3>

        <div class="mb-5">
          <p class="text-indigo-600 text-lg text-center">
            Êtes-vous sûr de vouloir désactiver le modèle de page "{{ templateNameToDeactivate }}" ?
          </p>
        </div>

        <div class="mb-10">
          <p class="text-pink-600 text-lg text-center">
            Attention, ce modèle de page est utilisé par {{ listAssignedUsersTemplate.length }} bénéficiaire<span v-if="listAssignedUsersTemplate.length > 1">s</span> :
          </p>
          <p class="text-pink-600 text-lg text-center mb-5">
            <span
              v-for="(beneficiary, index) in listAssignedUsersTemplate"
              :key="beneficiary.id"
            >
              <span v-if="index > 0">-&nbsp;</span>{{ beneficiary.firstname }} <span class="uppercase">{{ beneficiary.lastname }}</span>
            </span>
          </p>
          <p class="text-pink-600 text-lg text-center">
            En cas de désactivation, le modèle de page "{{ templatePageToAssignAfterDelete.name }}" {{ listAssignedUsersTemplate.length > 1 ? 'leur' : 'lui' }} sera attribué.
          </p>
        </div>

        <div class="flex space-x-4 justify-center bg-pink">
          <action-button
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-300"
            libelle="ANNULER"
            @clickAction="close(-1)"
          />
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            :uppercase="true"
            libelle="DESACTIVER"
            type-shadow="shadow-pink"
            @clickAction="confirm_deactivate_template(templatePageToAssignAfterDelete)"
          />
        </div>
      </div>
    </div>
    <!-- END If template to delete is assigned on at least 1 beneficiary -->
  </popup>
</template>

<script>
import Popup from './../Popup';
import ActionButton from './../ActionButton';
import Illustration from './../Illustration';
import Icon from './../Icon';

export default {
  components:{
    Popup,
    ActionButton,
    Illustration,
    Icon
  },

  props:{
    confirmDeactivateTemplate:{
      type: Number,
      required: false,
      default:-1,
    },
    templateNameToDeactivate:{
      type: String,
      required: false,
      default: '',
    },
    listAssignedUsersTemplate:{
      type: Array,
      required: false,
      default:[],
    },
    templatePageToAssignAfterDelete:{
      type:Object,
      required: false,
      default:{},
    },
  },

  methods:{
    confirm_deactivate_template(template = null){
      this.$emit('confirm_deactivate_template', template);
    },
    close(){
      this.$emit('close');
    }
  }
};
</script>
